const MuiInput = {
  styleOverrides: {
    root: {
      marginTop: 4,
      padding: 0,
    },
    underline: {
      '&:before, &&:hover:before, &:after': {
        border: 'none',
      },
      '&$disabled:before': {
        border: 'none !important',
      },
    },
  },
};

export default MuiInput;
